import { render } from "./EditSalesReturn.vue?vue&type=template&id=077d46fc"
import script from "./EditSalesReturn.vue?vue&type=script&lang=js"
export * from "./EditSalesReturn.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__